import $ from 'jquery';
import Swiper, { Navigation, Thumbs, Pagination } from 'swiper';
export const init = async function() {
    // configure Swiper to use modules
    Swiper.use([
        Navigation,
        Pagination,
        Thumbs
    ]);
    let thumbsSwiper;
    let imageSwiper;
    const initCarousel = (productHandle)=>{
        thumbsSwiper = new Swiper('.js-quick-view-thumbs[product-handle="' + productHandle + '"]', {
            spaceBetween: 12,
            slidesPerView: 'auto',
            freeMode: true,
            autoHeight: false,
            watchSlidesProgress: true,
            direction: 'vertical',
            observer: true
        });
        imageSwiper = new Swiper('.js-quick-view-carousel[product-handle="' + productHandle + '"]', {
            autoHeight: false,
            direction: 'horizontal',
            init: false,
            loop: false,
            slidesPerView: 1,
            centerInsufficientSlides: false,
            centeredSlides: false,
            observer: true,
            thumbs: {
                swiper: thumbsSwiper
            },
            pagination: {
                el: '.swiper-pagination'
            },
            breakpoints: {
                1024: {
                    direction: 'vertical'
                }
            }
        });
    };
    // show quick view modal
    $('.js-quick-view-trigger').on('click', function(e) {
        e.preventDefault();
        const prodHandle = $(this).attr('prod-handle');
        const carHandle = $(this).attr('car-handle');
        // show correct modal & overlay
        $('.js-quick-view[product-handle="' + prodHandle + '"]').show();
        $('.QuickView-overlay[product-handle="' + prodHandle + '"]').show();
        // show correct content
        $('.QuickView-content').removeClass('active');
        $('.QuickView-content[prod-handle="' + (carHandle || prodHandle) + '"]').addClass('active');
        // filter images content
        $('.QuickView-slideThumbs').hide();
        $('.QuickView-slideThumbs[data-filter="' + (carHandle || prodHandle) + '"]').show();
        $('.QuickView-slideThumbs[data-filter="' + (carHandle || prodHandle) + '"]').addClass('swiper-slide');
        $('.QuickView-slide').hide();
        $('.QuickView-slide[data-filter="' + (carHandle || prodHandle) + '"]').show();
        $('.QuickView-slide[data-filter="' + (carHandle || prodHandle) + '"]').addClass('swiper-slide');
        // init carousel
        if (prodHandle === undefined) {
            return;
        }
        initCarousel(prodHandle);
        thumbsSwiper.init();
        imageSwiper.init();
    });
    // hide quick view modal
    $('.js-quick-view-close').on('click', function() {
        const prodHandle = $(this).attr('product-handle');
        // hide modal & overlay
        $('.js-quick-view[product-handle="' + prodHandle + '"]').fadeOut();
        $('.QuickView-overlay[product-handle="' + prodHandle + '"]').hide();
        // destroy carousels
        thumbsSwiper !== undefined ? thumbsSwiper.destroy(true, true) : '';
        imageSwiper !== undefined ? imageSwiper.destroy(true, true) : '';
    });
    // change color swatch
    $('[js-quick-view-color-swatches]').on('click', function() {
        const prodHandle = $(this).attr('prod-handle');
        // change content
        $('.QuickView-content').removeClass('active');
        $('.QuickView-content[prod-handle="' + prodHandle + '"]').addClass('active');
        // filter images content
        $('.QuickView-slideThumbs').hide();
        $('.QuickView-slideThumbs').removeClass('swiper-slide');
        $('.QuickView-slideThumbs[data-filter="' + prodHandle + '"]').show();
        $('.QuickView-slideThumbs[data-filter="' + prodHandle + '"]').addClass('swiper-slide');
        $('.QuickView-slide').hide();
        $('.QuickView-slide').removeClass('swiper-slide');
        $('.QuickView-slide[data-filter="' + prodHandle + '"]').show();
        $('.QuickView-slide[data-filter="' + prodHandle + '"]').addClass('swiper-slide');
        imageSwiper.updateSlides();
        thumbsSwiper.updateSlides();
        thumbsSwiper !== undefined ? thumbsSwiper.update() : '';
        imageSwiper.update();
        imageSwiper.thumbs.update(true);
    });
};
